import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import logoDeitres from '@/assets/logo_deitres.svg'
import logoCitymesh from '@/assets/logo_citymesh.svg'
import logoAmiar from '@/assets/logo_amiar.svg'
import { useTranslation } from 'react-i18next'

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Background = styled.div`
  position: absolute;
  width: 200%;
  height: 200%;
  top: -50%;
  left: -50%;
  background-color: black;
  background-image:
    radial-gradient(circle at 30% 30%, #49c0ef, transparent 40%),
    radial-gradient(circle at 70% 30%, #f8af15, transparent 40%),
    radial-gradient(circle at 50% 70%, #de232c, transparent 40%);
  animation: ${rotate} 15s linear infinite;
  z-index: -1;
`

const Card = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const MainLogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
  user-select: none;

  @media (max-width: 1060px) {
    transform: scale(0.65);
  }
`

const LogoTop = styled.span`
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 52px;
  font-weight: 800;
  letter-spacing: -1px;
  color: #ffffff;
`

const LogoBottom = styled.span`
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 8px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.85);
`

const BottomLogosWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  position: absolute;
  bottom: 48px;

  @media (max-width: 1060px) {
    display: none;
  }
`

const SmallLogo = styled.img`
  height: auto;
`

const Link = styled.a``

const GradientCard = () => {
  const { t } = useTranslation()

  return (
    <Card>
      <Background />
      <MainLogoWrapper>
        <LogoTop>Deitres</LogoTop>
        <LogoBottom>Chat</LogoBottom>
      </MainLogoWrapper>
      <BottomLogosWrapper>
        <Link href={t('links.deitres')} target="_blank">
          <SmallLogo src={logoDeitres} alt="Deitres logo" />
        </Link>
        <Link href={t('links.citymesh')} target="_blank">
          <SmallLogo src={logoCitymesh} alt="Citymesh logo" />
        </Link>
        <Link href={t('links.amiar')} target="_blank">
          <SmallLogo src={logoAmiar} alt="Amiar logo" />
        </Link>
      </BottomLogosWrapper>
    </Card>
  )
}

export default GradientCard
